<template lang="html">
    <div class="pagination-wrapper">
        <router-link @click.prevent="navigateTo(previous)" to="" :class="`link-card ${!previous?.id ? 'disabled' : ''}`">
            <div class="prevnext"
                :class="`prevnext ${ previous?.id  ? 'active' : ''}`"
            >
                <span class="text">ANTERIOR</span>
                <span class="icon-arrow-prev">
                    <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M26.7143 28.5714L18.1429 20L26.7143 11.4286L25 8L13 20L25 32L26.7143 28.5714Z"
                            fill="url(#paint0_radial_164_231)"
                            fill-opacity="0.97"
                        />
                        <defs>
                            <radialGradient
                                id="paint0_radial_164_231"
                                cx="0"
                                cy="0"
                                r="1"
                                gradientUnits="userSpaceOnUse"
                                gradientTransform="translate(19.8571 24.56) rotate(-90) scale(16.56 9.46286)"
                            >
                                <stop stop-color="white" />
                                <stop offset="1" stop-color="white" />
                            </radialGradient>
                        </defs>
                    </svg>
                </span>
            </div>
        </router-link>
        <div class="number-pages" >
            <div class="number">{{position}}</div>{{' / '}}<div class="number">{{count}}</div>
        </div>
        <router-link @click.prevent="navigateTo(next)" to="" :class="`link-card ${!next?.id ? 'disabled' : ''}`">
            <div 
                :class="`prevnext ${ next?.id ? 'active' : ''}`"
            >
                <span class="icon-arrow-prev">
                    <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M13.2857 11.4286L21.8571 20L13.2857 28.5714L15 32L27 20L15 8L13.2857 11.4286Z"
                            fill="white"
                        />
                    </svg>
                </span>
                <span class="text">SIGUIENTE</span>
            </div>
        </router-link>
    </div>
</template>
<script>
export default {
    props: ['previous','next','route', 'position','count'],
    created() {
        console.log(this.previous);
        console.log({route:this.$router});
    },
    methods: {
    escapeQuestionMark(text) {
      return text.replace(/\?/g, '%3F');
    },

    getFormattedLink(previous) {
        console.log({previous})
      const escapedTitle = this.escapeQuestionMark(previous?.title);
      return `/categoria/${this.route}/${escapedTitle}?id=${previous?.id}`;
    },
    navigateTo(previous) {
      if (previous?.id) {
        this.$router.push(this.getFormattedLink(previous));
      }
    }
  },
}
</script>
<style lang="css" scoped>
.pagination-wrapper {
    width: 480px;
    height: 60px;
    background: radial-gradient(
        69% 69% at 50% 31%,
        rgba(51, 100, 126, 0.97) 0%,
        rgba(1, 54, 82, 0.97) 100%
    );
    padding: 10px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}
.pagination-wrapper .prevnext {
    display: flex;
    align-items: center;
    cursor: pointer;
}
.pagination-wrapper .prevnext .text {
    font-family: "Roboto Condensed", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 23px;
    color: rgba(255, 255, 255, 0.98);
}
.pagination-wrapper .prevnext.active {
    opacity: 1;
}
.pagination-wrapper .prevnext {
    opacity: 0.5;
}
.pagination-wrapper .number-pages {
    display: flex;
    align-items: center;
}
.pagination-wrapper .number-pages .number {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 21px;
    text-transform: uppercase;
    color: #ffffff;
    min-width: 38px;
    width: 38px;
    height: 38px;
    margin: 0 2px;
    cursor: pointer;
}
.pagination-wrapper .number-pages .number.active {
    background: rgba(255, 255, 255, 0.97);
    border-radius: 100%;
    color: #33647e;
}
.link-card.disabled {
    pointer-events: none
}

@media (max-width: 768px) {
    .pagination-wrapper {
        padding: 8px 20px;
    }
    .pagination-wrapper .prevnext .text {
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
    }

    .pagination-wrapper .number-pages .number {
        font-size: 14px;
        line-height: 16px;
    }
}
</style>